export default __webpack_public_path__ + "media/images/halloween/clouds-428f515b1ef88e899bb9b43ed1c9bbb7.png";